<div class="mobility-phone-step">
  <p class="mobility-phone-step__description">
    {{ 'user-agreement-sign-page.mobility-budget.phone-step.description' | translate }}
  </p>

  <div class="mobility-phone-step__form">
    <div class="mobility-phone-step__input-group">
      <app-mobility-budget-phone-input
        [isConfirmed]="isConfirmed()"
        [savedPhoneNumber]="savedPhoneNumber()"
        (savedPhoneParsed)="onSavedPhoneParsed()"
      />
    </div>

    @if (isConfirmed()) {
      <span class="mobility-phone-step__confirmed-label">
        {{ 'user-agreement-sign-page.mobility-budget.phone-step.confirmed' | translate }}
      </span>
    } @else {
      <button
        class="mobility-phone-step__confirm-button fo-color-secondary"
        matButton="filled"
        type="button"
        [disabled]="!phoneInput()?.isValid() || isSaving()"
        (click)="confirmPhone()"
      >
        {{ 'general.conf' | translate }}
      </button>
    }
  </div>

  <div class="mobility-phone-step__legal-notice">
    <mat-icon
      class="mobility-phone-step__legal-icon"
      svgIcon="fo-info-guard"
      [style.color]="wls.primaryColor"
    ></mat-icon>
    <div class="mobility-phone-step__legal-text">
      <p class="mobility-phone-step__legal-line">
        {{ 'user-agreement-sign-page.mobility-budget.phone-step.legal-line-1' | translate }}
      </p>
      <p class="mobility-phone-step__legal-line">
        {{ 'user-agreement-sign-page.mobility-budget.phone-step.legal-line-2' | translate }}
        <a
          class="mobility-phone-step__legal-link"
          rel="noopener noreferrer"
          target="_blank"
          [href]="
            'user-agreement-sign-page.mobility-budget.phone-step.privacy-link-url' | translate
          "
        >
          {{ 'user-agreement-sign-page.mobility-budget.phone-step.privacy-link' | translate }} </a
        >.
      </p>
    </div>
  </div>
</div>
